import React from 'react';
import PropTypes from 'prop-types';
import useWindowSize from 'hooks/useWindowSize';
import { SCREEN_SIZES } from 'style';
import {
  Content,
  CustomModal,
  Header,
  ModalMobileWave,
  ModalWave,
  Heading,
  Logo,
  MobileCloseButton
} from './styled';

const BaseModal = ({
  onClose,
  isOpen,
  children,
  isScrollable,
  headerColor,
  headerLogo,
  heading,
  className
}) => {
  const { width } = useWindowSize();
  const isDesktop = width >= SCREEN_SIZES.tabletLandscape;

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      variant={isDesktop ? null : 'fullScreen'}
      headerLogo={isDesktop ? null : headerLogo ?? <Logo />}
      isScrollable={isScrollable}
      className={className}
    >
      <Header headerColor={headerColor} />
      <ModalWave $headerColor={headerColor} />
      <ModalMobileWave $headerColor={headerColor} />
      <MobileCloseButton icon="fa-solid fa-chevron-left" onClick={onClose} />
      <Content>
        {heading && <Heading>{heading}</Heading>}
        {children}
      </Content>
    </CustomModal>
  );
};

BaseModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  isScrollable: PropTypes.bool,
  headerColor: PropTypes.string,
  headerLogo: PropTypes.node,
  heading: PropTypes.string,
  className: PropTypes.string
};

export default BaseModal;
